"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServicesVideoLiveTypeGroupSchema = void 0;
exports.ServicesVideoLiveTypeGroupSchema = {
    "$id": "https://www.redbull.com/schemas/type-groups/services/video/live.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ServicesVideoLiveTypeGroup",
    "description": "ServicesVideoLiveTypeGroup represents one of the following types: RBMNLive, RedBullTVLiveVideostream, ServusTVLiveVideo, TwitchLiveVideo, TwitchLiveVideo",
    "oneOf": [
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/rbmn-live/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/redbull_tv-live/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/servus-tv-livevideo/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/1.schema.json"
        },
        {
            "type": "object",
            "$ref": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/2.schema.json"
        }
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibGl2ZS5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy90eXBlLWdyb3Vwcy9zZXJ2aWNlcy92aWRlby9saXZlLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGdDQUFnQyxHQUFHO0lBQzlDLEtBQUssRUFBRSw2RUFBNkU7SUFDcEYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsNEJBQTRCO0lBQ3JDLGFBQWEsRUFBRSwySkFBMko7SUFDMUssT0FBTyxFQUFFO1FBQ1A7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsOEVBQThFO1NBQ3ZGO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsb0ZBQW9GO1NBQzdGO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUsd0ZBQXdGO1NBQ2pHO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUscUZBQXFGO1NBQzlGO1FBQ0Q7WUFDRSxNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUUscUZBQXFGO1NBQzlGO0tBQ0Y7Q0FDRixDQUFBIn0=